import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "5ad5ac4d-b1f4-4b0f-bf21-7fda4b92c78a",
  publicId: "28",
  name: "Special construction types using vibration isolation",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, task01, task02],
};

export default lesson;
